/* Block styles */
import "./block.scss";

wp.domReady(() => {
    let button = document.querySelector(
        "button.wp-block-navigation__responsive-container-open"
    );

    button.querySelector("svg").remove();
    const img = document.createElement("img");
    img.src = `https://${window.location.hostname}/wp-content/themes/porritt-group/assets/images/menu-line.png`;
    button.appendChild(img);
});
